import { render, staticRenderFns } from "./create-order.vue?vue&type=template&id=7887d7d6&scoped=true&"
import script from "./create-order.vue?vue&type=script&lang=js&"
export * from "./create-order.vue?vue&type=script&lang=js&"
import style0 from "./create-order.vue?vue&type=style&index=0&id=7887d7d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7887d7d6",
  null
  
)

export default component.exports